"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rangeComparisonHandler = void 0;
var luxon_1 = require("luxon");
var canIUseRangeComparison = function (range) {
    return Array.isArray(range) && range.length === 2;
};
var isString = function (value) {
    return typeof value === "string";
};
var canIUseRangeStringComparison = function (range, compareValue) {
    return isString(compareValue) && isString(range[0]) && isString(range[1]);
};
var rangeStringComparison = function (range, compareValue) {
    var lowerLimit = range[0], upperLimit = range[1];
    return compareValue >= lowerLimit && compareValue <= upperLimit;
};
var isNumber = function (value) {
    return typeof value === "number";
};
var canIUseRangeNumericComparison = function (range, compareValue) {
    return isNumber(compareValue) && isNumber(range[0]) && isNumber(range[1]);
};
var rangeNumericComparison = function (range, compareValue) {
    var lowerLimit = range[0], upperLimit = range[1];
    return compareValue >= lowerLimit && compareValue <= upperLimit;
};
var isDateInstance = function (value) {
    return value instanceof luxon_1.DateTime;
};
var canIUseRangeDateComparison = function (range, compareValue) {
    return (isDateInstance(compareValue) &&
        isDateInstance(range[0]) &&
        isDateInstance(range[1]));
};
var rangeDateComparison = function (range, compareValue) {
    var lowerLimit = range[0], upperLimit = range[1];
    return compareValue >= lowerLimit && compareValue <= upperLimit;
};
var rangeComparisonHandler = function (compare, range) {
    if (!canIUseRangeComparison(range)) {
        return false;
    }
    var validRange = range;
    if (canIUseRangeStringComparison(validRange, compare)) {
        var validStringRange = range;
        var validStringCompare = compare;
        var comparisonResult = rangeStringComparison(validStringRange, validStringCompare);
        return comparisonResult;
    }
    if (canIUseRangeNumericComparison(validRange, compare)) {
        var validNumericRange = range;
        var validNumericCompare = compare;
        return rangeNumericComparison(validNumericRange, validNumericCompare);
    }
    if (canIUseRangeDateComparison(validRange, compare)) {
        var validDateRange = range;
        var validDateCompare = compare;
        return rangeDateComparison(validDateRange, validDateCompare);
    }
    return false;
};
exports.rangeComparisonHandler = rangeComparisonHandler;
//# sourceMappingURL=rangeComparisonHandler.js.map